var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled, css } from '@web/theme';
import chroma from 'chroma-js';
var headerStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-family: ", ";\n\tline-height: 130%;\n\tcolor: ", ";\n\ttext-shadow: 0 1px 1px ", ";\n\ttext-align: left;\n\tpadding: 0 1.5rem;\n\t\n\tstrong {\n\t  font-weight: 700;\n\t}\n\t\n\ta {\n\t\tcolor: inherit;\n\t}\n"], ["\n\tfont-family: ", ";\n\tline-height: 130%;\n\tcolor: ", ";\n\ttext-shadow: 0 1px 1px ", ";\n\ttext-align: left;\n\tpadding: 0 1.5rem;\n\t\n\tstrong {\n\t  font-weight: 700;\n\t}\n\t\n\ta {\n\t\tcolor: inherit;\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.page.txt;
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.page.txt).alpha(.2).hex();
});
export var H1 = styled.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), headerStyles);
export var H2 = styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), headerStyles);
export var H3 = styled.h3(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), headerStyles);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
